import React from 'react';
import { useSelector } from 'react-redux';
import _ from 'lodash';
import classes from '../dashboard.module.scss';
import accountHelpers from '../../../../utils/accountHelpers';
import Loader from '../../../_common/Loader/Loader';

const DashboardStats = () => {
  const { dashboardStats } = useSelector((store) => store.dashboard);
  const isHealth = accountHelpers.isInRole('Health');
  const isRep = accountHelpers.isInRole('Rep');
  const isManufacturerUsers = accountHelpers.isInOneOfRoles(['Manufacturer Users']);

  const hasProfitAccess = accountHelpers.isInRole('Health')
    && accountHelpers.getUser().healthUser?.[0].canSeeProfit;

  return (
    <div className={classes.stats_wrapper}>
      { _.isEmpty(dashboardStats)
        ? <Loader />

        : (
          <>
            <div className={classes.stats}>
              <h3>{`$${isNaN(dashboardStats.revenue) ? 0 : new Intl.NumberFormat('us-US').format(dashboardStats.revenue)}`}</h3>

              <p>Total Sales</p>
            </div>

            {!isHealth && (
            <div className={classes.stats}>
              <h3>{`$${isNaN(dashboardStats.dailyAvgRevenue) ? 0 : new Intl.NumberFormat('us-US').format(dashboardStats.dailyAvgRevenue)}`}</h3>

              <p>Daily AVG Total Sales</p>
            </div>
            )}

            {!isHealth && !isManufacturerUsers && (
            <div className={classes.stats}>
              <h3>{`$${isNaN(dashboardStats.cost) ? 0 : new Intl.NumberFormat('us-US').format(dashboardStats.cost)}`}</h3>

              <p>Cost</p>
            </div>
            )}

            {(hasProfitAccess || !isHealth) && !isRep && !isManufacturerUsers && (
              <div className={classes.stats}>
                <h3>{`$${isNaN(dashboardStats.profit) ? 0 : new Intl.NumberFormat('us-US').format(dashboardStats.profit)}`}</h3>

                <p>Profit</p>
              </div>
            )}

            {!isHealth && !isRep && (
            <div className={classes.stats}>
              <h3>{`$${isNaN(dashboardStats.dailyAvgProfit) ? 0 : new Intl.NumberFormat('us-US').format(dashboardStats.dailyAvgProfit)}`}</h3>

              <p>Daily AVG Profit</p>
            </div>
            )}

            <div className={classes.stats}>
              <h3>{isNaN(dashboardStats.sales) ? 0 : new Intl.NumberFormat('us-US').format(dashboardStats.sales)}</h3>

              <p>Prescription count</p>
            </div>

            {!isHealth && (
            <div className={classes.stats}>
              <h3>{`$${isNaN(dashboardStats.revenuePerSale) ? 0 : new Intl.NumberFormat('us-US').format(dashboardStats.revenuePerSale)}`}</h3>

              <p>Total Sales per sale</p>
            </div>
            )}

            <div className={classes.stats}>
              <h3>{isNaN(dashboardStats.repeatPatients) ? 0 : new Intl.NumberFormat('us-US').format(dashboardStats.repeatPatients)}</h3>

              <p>Repeat patients</p>
            </div>

            <div className={classes.stats}>
              <h3>{isNaN(dashboardStats.newPatients) ? 0 : new Intl.NumberFormat('us-US').format(dashboardStats.newPatients)}</h3>

              <p>New patients</p>
            </div>

            <div className={classes.stats}>
              <h3>{isNaN(dashboardStats.newPhysicians) ? 0 : new Intl.NumberFormat('us-US').format(dashboardStats.newPhysicians)}</h3>

              <p>New physicians</p>
            </div>

            {!isHealth && !isManufacturerUsers && (
            <div className={classes.stats}>
              <h3>{`${isNaN(dashboardStats.margin) ? 0 : new Intl.NumberFormat('us-US').format(dashboardStats.margin)}%`}</h3>

              <p>Margin</p>
            </div>
            )}

            {!!dashboardStats.healthRefill?.length && (
            <>
              <div className={classes.stats}>
                <h3>{`${isNaN(dashboardStats.healthRefill[0].refill) ? 0 : new Intl.NumberFormat('us-US').format(dashboardStats.healthRefill[0].refill)}`}</h3>

                <p>Refill too Soon Members</p>
              </div>

              <div className={classes.stats}>
                <h3>{`${isNaN(dashboardStats.healthRefill[0].refillNew) ? 0 : new Intl.NumberFormat('us-US').format(dashboardStats.healthRefill[0].refillNew)}`}</h3>

                <p>Refill too Soon New Members</p>
              </div>
            </>
            )}
          </>
        )}
    </div>
  );
};

export default DashboardStats;
